import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer';
import submissionReducer from './reducers/submissionReducer';
import orderReducer from './reducers/orderReducer';
import fileReducer from './reducers/fileReducer';
import userReducer from './reducers/userReducer';
import notificationReducer from './reducers/notificationReducer';
import companyReducer from './reducers/companyReducer';
import uiReducer from './reducers/uiReducer';
import alertSettingsReducer from './reducers/alertSettingsReducer';

const store = configureStore({
  reducer: {
    auth: authReducer,
    submissions: submissionReducer,
    orders: orderReducer,
    files: fileReducer,
    users: userReducer,
    notifications: notificationReducer,
    ui: uiReducer,
    companies: companyReducer,
    alertSettings: alertSettingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;